import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import { queryParamsModule } from '@/modules/queryParams';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useOnboarding } from '@/pages/Onboarding/context';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataKeyType, LayoutDataType } from '../../types';

import { OPTIONS } from './constants';
import './Outfit.scss';

export const OnboardingReplikaOutFit: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Outfit',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const outfits = form.watch('outfits');

  const handleNextStep = (): void => {
    const option = OPTIONS.find((item) => item.id === outfits);
    userService.createOrUpdate({
      onboarding_data: {
        outfits: option?.title ?? '',
      },
    });
    wizard.nextStep();
  };

  const handleBackStep = (): void => {
    wizard.goToStep('interaction');
  };

  return (
    <OnboardingPage className="onboarding-outfit">
      <OnboardingNavigation onBack={handleBackStep} />

      <IonContent>
        <OnboardingTitle className="onboarding-outfit__title">
          Give your character a jaw-dropping outfit – ready to try?👙
        </OnboardingTitle>
        <OnboardingOptionsList>
          {OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={outfits === option.id}
              control={form.control}
              option={option}
              name="outfits"
              key={option.id}
              onChange={(value) => {
                queryParamsModule.setParam<LayoutDataKeyType>('outfits', value);
              }}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} disabled={!outfits} />
    </OnboardingPage>
  );
};
